import React from 'react';
export function ProductShowcase() {
  const row1Colors = ['bg-blue-700', 'bg-blue-800', 'bg-cyan-700', 'bg-teal-700', 'bg-sky-700', 'bg-indigo-700'];
  const row2Colors = ['bg-emerald-700', 'bg-teal-800', 'bg-cyan-800', 'bg-blue-800', 'bg-indigo-700', 'bg-violet-700'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[10px] pb-[10px]" data-id="element-224">
      <div className="max-w-5xl mx-auto text-center" data-id="element-225">
        <div data-id="element-226">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-227">
            <span className="text-xl" data-id="element-228">🧮</span> PROFEPACK
          </div>

          <div className="inline-block bg-brand-accent/10 border border-brand-accent/30 text-brand-accent px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-229">
            🏆 Sistema N°1 para docentes de Matemática en Argentina
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 uppercase text-brand-accent" data-id="element-230">
            Megapack Matemática Lista
          </h2>

          <div className="mb-12 flex flex-col gap-2" data-id="element-231">
            <p className="text-xl md:text-2xl text-white font-bold" data-id="element-232">
              12 tomos organizados por grado y año.
            </p>
            <p className="text-base md:text-lg text-white/70 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-233">
              240 clases con secuencia completa. 6 bonos estratégicos. Todo
              listo para usar desde hoy.
            </p>
          </div>
        </div>

        {/* Grid Showcase */}
        <div className="relative max-w-3xl mx-auto mb-16" data-id="element-234">
          <div className="grid grid-cols-6 gap-2 md:gap-3 mb-2" data-id="element-235">
            {row1Colors.map((color, i) => <div key={`r1-${i}`} className={`${color} border-2 border-brand-accent rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-236">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-237">
                  {i + 1}°
                </span>
              </div>)}
          </div>
          <div className="text-white/50 text-sm font-bold tracking-widest uppercase mb-6 flex items-center justify-end pr-2" data-id="element-238">
            ← PRIMARIA
          </div>

          <div className="grid grid-cols-6 gap-2 md:gap-3 mb-2" data-id="element-239">
            {row2Colors.map((color, i) => <div key={`r2-${i}`} className={`${color} border-2 border-brand-accent rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-240">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-241">
                  {i + 1}°
                </span>
              </div>)}
          </div>
          <div className="text-white/50 text-sm font-bold tracking-widest uppercase mb-6 flex items-center justify-end pr-2" data-id="element-242">
            ← SECUNDARIA
          </div>

          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-brand-card border-2 border-brand-accent text-brand-accent px-6 py-2 rounded-full font-bold text-sm md:text-base whitespace-nowrap shadow-xl z-10" data-id="element-243">
            12 TOMOS COMPLETOS
          </div>
        </div>

        {/* Feature Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-2xl mx-auto mt-12" data-id="element-244">
          {['✅ Por grado/año', '✅ Con secuencia didáctica', '✅ Con evaluación', '✅ Con bonos'].map((item, i) => <div key={i} className="bg-brand-card border border-brand-accent px-5 py-2.5 rounded-full flex items-center gap-2 shadow-sm" data-id="element-245">
              <span className="font-medium text-white/90 text-sm md:text-base" data-id="element-246">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}